import React from "react";
import BaseDetails, { DetailRow } from "./baseDetails";

export default function scenarioCreateDetails({ row }) {
    return (
        <BaseDetails row={row}>
            <DetailRow label="Based On">
                {row.from_scenario_name || <span className="text-slate-400 italic">Blank scenario</span>}
            </DetailRow>
            <DetailRow label="New Name">
                <span className="font-medium">{row.scenario_name}</span>
            </DetailRow>
        </BaseDetails>
    );
}
